//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _doingView_file_attachment from './doingView_file_attachment';
export const doingView_file_attachment = _doingView_file_attachment;
export default {doingView_file_attachment};

